import { ResourceType } from '@prisma/client';
import { useFormikContext } from 'formik';

import { mergeMimeTypes } from 'src/utils/utils';

import { CustomInput } from '../CustomInput';
import { FileUploadSelect } from '../FormikComponents';

const ResourceUploader = () => {
    const { values, errors, setFieldValue } = useFormikContext();

    const resourceConfig = {
        [ResourceType.Document]: {
            component: FileUploadSelect,
            props: {
                name: 'resourceURL',
                label: 'Upload Document',
                acceptedFileTypes: mergeMimeTypes('images', 'documents'),
            },
        },
        [ResourceType.Video]: {
            component: FileUploadSelect,
            props: {
                name: 'resourceURL',
                label: 'Upload Media File',
                acceptedFileTypes: mergeMimeTypes('videos'),
            },
        },
        [ResourceType.Link]: {
            component: CustomInput,
            props: {
                name: 'resourceURL',
                label: 'Please enter the URL for the External Resource',
                placeholder: 'Enter or paste the URL to the external resource...',
                onChange: (event) => setFieldValue('resourceURL', event.target.value),
                value: values.resourceURL,
                error: errors.resourceURL,
            },
        },
    };

    const resourceData = resourceConfig[values.resource_type];

    if (resourceData) {
        const ResourceComponent = resourceData.component;
        const componentProps = resourceData.props;

        return <ResourceComponent {...componentProps} />;
    }

    return null;
};

export default ResourceUploader;
